// import React, { useEffect, useState } from "react";
// import { auth, firestore as db } from "../FirebaseConfig";
// import { collection, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
// import { onAuthStateChanged } from "firebase/auth";
// import { useNavigate } from "react-router-dom";
// import {  IoTrashBin } from "react-icons/io5";

// export default function CartPage() {
//   const [cartItems, setCartItems] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [userId, setUserId] = useState(null);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);


//   const handleCheckout = async () => {
//     navigate("/checkout");
//   };
  
  
//   <button
//     onClick={handleCheckout}
//     className="hidden md:block mt-4 bg-blue-500 text-white px-6 py-2 rounded-md w-full hover:bg-blue-600"
//   >
//     Proceed to Checkout →
//   </button>;



//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setUserId(user.uid);
//       } else {
//         setUserId(null);
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (userId) {
//       const fetchCartItems = async () => {
//         const cartRef = doc(db, "customers", userId);
//         const cartSnap = await getDoc(cartRef);
//         if (cartSnap.exists()) {
//           setCartItems(cartSnap.data().items || []);
//           // setAddress(cartSnap.data().address[cartSnap.data().defaultAddress]);
//         }
//       };
//       fetchCartItems();
//     }
//   }, [userId]);

//   useEffect(() => {
//     const fetchProductDetails = async () => {
//       const productsCollection = collection(db, "products");
//       const productSnapshots = await getDocs(productsCollection);
//       const productData = {};
//       productSnapshots.forEach((doc) => {
//         productData[doc.id] = doc.data();
//       });
//       setProducts(productData);
//     };
//     fetchProductDetails();
//   }, []);

//   const updateQuantity = async (productId, change) => {
//     const updatedItems = cartItems.map((item) => {
//       if (item.productId !== productId) return item; // Keep other items unchanged
  
//       const product = products[item.productId];
//       if (!product) return item;
  
//       const newQuantity = item.quantity + change;
//       if (newQuantity > product.stock) return item; // Prevent exceeding stock limit
  
//       return newQuantity > 0 ? { ...item, quantity: newQuantity } : null; // Remove if quantity is 0
//     }).filter(Boolean); // Remove null values (products with quantity 0)
  
//     setCartItems(updatedItems);
//     await updateDoc(doc(db, "customers", userId), { items: updatedItems });
//   };
  
//   const removeItem = async (productId) => {
//     const updatedItems = cartItems.filter((item) => item.productId !== productId);
//     setCartItems(updatedItems);
//     await updateDoc(doc(db, "customers", userId), { items: updatedItems });
//   };

//   const subtotal = cartItems.reduce((acc, item) => {
//     const product = products[item.productId];
//     if (product) {
//       const finalPrice = product.prices.productPrice - product.prices.productDiscount;
//       return acc + finalPrice * item.quantity;
//     }
//     return acc;
//   }, 0);

//   const gstAmount = subtotal - subtotal / 1.05;
//   const totalPayable = subtotal;

//   return (
//     <div className="container mb-25 mx-auto p-4 mt-27">
//       <h2 className="text-3xl font-bold mb-6">Shopping Cart - {cartItems.length} items</h2>

//       <div className="grid md:grid-cols-3 gap-6">
//         {/* Cart Items Section */}
//         <div className="md:col-span-2 bg-white p-4 rounded-lg shadow-lg">
//           {cartItems.length === 0 ? (
//             <div>
//                <p className="text-lg text-gray-500 m-10">Your cart is empty.</p>
//               <button onClick={() => navigate("/shop")} className="hidden md:block mt-4 bg-blue-500 text-white px-6 py-2 rounded-md w-full hover:bg-blue-600">
//            Continue Shopping →
//           </button>
           
//             </div>
//           ) : (
//             cartItems.map((item) => {
//               const product = products[item.productId];
//               if (!product) return null;
//               const finalPrice = product.prices.productPrice - product.prices.productDiscount;

//               return (
//                 <div key={item.productId} className="flex items-center border-b py-4">
//                   <img src={product.thumbnail} alt={product.name} className="w-40 object-cover rounded-md" />
//                   <div className="ml-4 flex-1">
//                     <h3 className="text-sm font-semibold">{product.name}</h3>
//                     <p className="text-gray-500 text-sm">Category: {product.category}</p>
//                     <p className="text-green-600 font-bold">₹{finalPrice}</p>
//                     <div className="flex items-center mt-2">
//                       <button
//                         className="px-2 py-1 border rounded"
//                         onClick={() => updateQuantity(item.productId, -1)}
//                       >
//                         -
//                       </button>
//                       <span className="mx-2">{item.quantity}</span>
//                       <button
//                         className={`px-2 py-1 border rounded ${
//                           item.quantity >= product.stock ? "opacity-50 cursor-not-allowed" : ""
//                         }`}
//                         onClick={() => updateQuantity(item.productId, 1)}
//                         disabled={item.quantity >= product.stock}
//                       >
//                         +
//                       </button>
//                     </div>
//                     {item.quantity >= product.stock && (
//                       <p className="text-red-500 text-xs mt-1">Only {product.stock} in stock</p>
//                     )}
//                   </div>
//                   <IoTrashBin className="ml-4 h-8 w-40 text-red-500 " onClick={() => removeItem(item.productId)}/>
                 
//                 </div>
//               );
//             })
//           )}


//         </div>

//         {/* Summary Section */}
//        {cartItems.length !== 0 &&  <div className="bg-white p-4 rounded-lg shadow-lg">
//           <h3 className="text-lg font-bold mb-2">Summary</h3>
//           <p className="text-gray-700">Products: ₹{subtotal.toFixed(2)}</p>
//           <p className="text-gray-700">Inclusive of GST (5%): ₹{gstAmount.toFixed(2)}</p>
//           {/* <p className="text-gray-700">Shipping: ₹{deliveryCharge}</p> */}
//           <h3 className="text-xl font-bold mt-2">Total: ₹{totalPayable.toFixed(2)}</h3>

//           <button onClick={handleCheckout} className="hidden md:block mt-4 bg-blue-500 text-white px-6 py-2 rounded-md w-full hover:bg-blue-600">
//             Proceed to  Checkout →
//           </button>
//         </div>
// }
//       </div>

//       {/* Address Section */}
  
//       {/* Floating Bottom Bar for Mobile */}
//       {cartItems.length !== 0 &&    <div className="fixed bottom-0 left-0 w-full bg-green-600 text-white p-4 flex justify-between items-center md:hidden">
//         <div>
//           <p className="text-lg">{cartItems.length} items</p>
//           <p className="text-xl font-bold">₹{totalPayable.toFixed(2)}</p>
//         </div>
//         <button
//           onClick={handleCheckout}
//           className="bg-white text-green-600 px-6 py-2 rounded-md font-bold"
//         >
//           Checkout Now →
//         </button>
//       </div>
// }

//     </div>
//   );
// }


// import React, { useEffect, useState, useMemo } from "react";
// import { auth, firestore as db } from "../FirebaseConfig";
// import { collection, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
// import { onAuthStateChanged } from "firebase/auth";
// import { useNavigate } from "react-router-dom";
// import { IoTrashBin } from "react-icons/io5";

// export default function CartPage() {
//   const [cartItems, setCartItems] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [userId, setUserId] = useState(null);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);

//   const handleCheckout = async () => {
//     navigate("/checkout");
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       if (user) setUserId(user.uid);
//       else setUserId(null);
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (userId) {
//       const fetchCartItems = async () => {
//         const cartRef = doc(db, "customers", userId);
//         const cartSnap = await getDoc(cartRef);
//         if (cartSnap.exists()) {
//           setCartItems(cartSnap.data().items || []);
//         }
//         setLoading(false);
//       };
//       fetchCartItems();
//     } else {
//       setCartItems([]);
//       setLoading(false);
//     }
//   }, [userId]);

//   useEffect(() => {
//     const fetchProductDetails = async () => {
//       const productsCollection = collection(db, "products");
//       const productSnapshots = await getDocs(productsCollection);
//       const productData = {};
//       productSnapshots.forEach((docSnap) => {
//         productData[docSnap.id] = docSnap.data();
//       });
//       setProducts(productData);
//     };
//     fetchProductDetails();
//   }, []);

//   const updateQuantity = async (productId, change) => {
//     const updatedItems = cartItems
//       .map((item) => {
//         if (item.productId !== productId) return item;

//         const product = products[item.productId];
//         if (!product) return item;

//         const newQuantity = item.quantity + change;

//         // prevent < 1 and prevent exceeding stock
//         if (newQuantity < 1) return null;
//         if (newQuantity > product.stock) return item;

//         return { ...item, quantity: newQuantity };
//       })
//       .filter(Boolean);

//     setCartItems(updatedItems);
//     if (userId) {
//       await updateDoc(doc(db, "customers", userId), { items: updatedItems });
//     }
//   };

//   const removeItem = async (productId) => {
//     const updatedItems = cartItems.filter((item) => item.productId !== productId);
//     setCartItems(updatedItems);
//     if (userId) {
//       await updateDoc(doc(db, "customers", userId), { items: updatedItems });
//     }
//   };

//   // ---- NEW: Stock validation ----
//   const stockIssues = useMemo(() => {
//     if (!cartItems?.length) return [];
//     const issues = [];

//     for (const item of cartItems) {
//       const product = products[item.productId];
//       if (!product) {
//         issues.push({
//           productId: item.productId,
//           type: "missing",
//           message: "Product no longer available.",
//         });
//         continue;
//       }
//       if (product.stock <= 0) {
//         issues.push({
//           productId: item.productId,
//           type: "oos",
//           message: "Out of stock.",
//         });
//         continue;
//       }
//       if (item.quantity > product.stock) {
//         issues.push({
//           productId: item.productId,
//           type: "insufficient",
//           message: `Only ${product.stock} left in stock.`,
//           available: product.stock,
//           requested: item.quantity,
//           name: product.name,
//         });
//       }
//     }
//     return issues;
//   }, [cartItems, products]);

//   const hasStockIssue = stockIssues.length > 0;

//   // Optional helper to auto-fix all quantities down to available
//   const fixQuantitiesToAvailable = async () => {
//     const fixed = cartItems
//       .map((item) => {
//         const product = products[item.productId];
//         if (!product || product.stock <= 0) return null;
//         const qty = Math.min(item.quantity, product.stock);
//         return { ...item, quantity: qty };
//       })
//       .filter(Boolean);

//     setCartItems(fixed);
//     if (userId) {
//       await updateDoc(doc(db, "customers", userId), { items: fixed });
//     }
//   };

//   const subtotal = cartItems.reduce((acc, item) => {
//     const product = products[item.productId];
//     if (product) {
//       const finalPrice = product.prices.productPrice - product.prices.productDiscount;
//       return acc + finalPrice * item.quantity;
//     }
//     return acc;
//   }, 0);

//   const gstAmount = subtotal - subtotal / 1.05;
//   const totalPayable = subtotal;

//   return (
//     <div className="container mb-25 mx-auto p-4 mt-27">
//       <h2 className="text-3xl font-bold mb-6">
//         Shopping Cart - {cartItems.length} {cartItems.length === 1 ? "item" : "items"}
//       </h2>

//       {/* Global warning banner when any stock issue exists */}
//       {hasStockIssue && (
//         <div className="mb-4 rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-800">
//           Some items exceed available stock. Please adjust quantities to continue.
//           <div className="mt-2 flex gap-2">
//             <button
//               onClick={fixQuantitiesToAvailable}
//               className="rounded-md bg-red-600 px-3 py-1 text-white hover:bg-red-700"
//             >
//               Adjust to available
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="grid md:grid-cols-3 gap-6">
//         {/* Cart Items Section */}
//         <div className="md:col-span-2 bg-white p-4 rounded-lg shadow-lg">
//           {cartItems.length === 0 ? (
//             <div>
//               <p className="m-10 text-lg text-gray-500">Your cart is empty.</p>
//               <button
//                 onClick={() => navigate("/shop")}
//                 className="hidden md:block mt-4 w-full rounded-md bg-blue-500 px-6 py-2 text-white hover:bg-blue-600"
//               >
//                 Continue Shopping →
//               </button>
//             </div>
//           ) : (
//             cartItems.map((item) => {
//               const product = products[item.productId];
//               if (!product) {
//                 return (
//                   <div key={item.productId} className="flex items-center border-b py-4">
//                     <div className="ml-4 flex-1">
//                       <h3 className="text-sm font-semibold">Unavailable product</h3>
//                       <p className="text-red-600 text-xs mt-1">This product is no longer available.</p>
//                     </div>
//                     <IoTrashBin
//                       className="ml-4 h-8 w-8 cursor-pointer text-red-500"
//                       onClick={() => removeItem(item.productId)}
//                     />
//                   </div>
//                 );
//               }

//               const finalPrice = product.prices.productPrice - product.prices.productDiscount;
//               const issue = stockIssues.find((i) => i.productId === item.productId);

//               return (
//                 <div key={item.productId} className="flex items-center border-b py-4">
//                   <img src={product.thumbnail} alt={product.name} className="w-40 object-cover rounded-md" />
//                   <div className="ml-4 flex-1">
//                     <h3 className="text-sm font-semibold">{product.name}</h3>
//                     <p className="text-gray-500 text-sm">Category: {product.category}</p>
//                     <p className="text-green-600 font-bold">₹{finalPrice}</p>
//                     <div className="mt-2 flex items-center">
//                       <button
//                         className="px-2 py-1 border rounded"
//                         onClick={() => updateQuantity(item.productId, -1)}
//                       >
//                         -
//                       </button>
//                       <span className="mx-2">{item.quantity}</span>
//                       <button
//                         className={`px-2 py-1 border rounded ${
//                           item.quantity >= product.stock ? "opacity-50 cursor-not-allowed" : ""
//                         }`}
//                         onClick={() => updateQuantity(item.productId, 1)}
//                         disabled={item.quantity >= product.stock}
//                       >
//                         +
//                       </button>
//                     </div>

//                     {/* Per-item warning */}
//                     {issue && (
//                       <p className="text-red-500 text-xs mt-1">{issue.message}</p>
//                     )}
//                   </div>
//                   <IoTrashBin
//                     className="ml-4 h-8 w-8 cursor-pointer text-red-500"
//                     onClick={() => removeItem(item.productId)}
//                   />
//                 </div>
//               );
//             })
//           )}
//         </div>

//         {/* Summary Section */}
//         {cartItems.length !== 0 && (
//           <div className="bg-white p-4 rounded-lg shadow-lg">
//             <h3 className="text-lg font-bold mb-2">Summary</h3>
//             <p className="text-gray-700">Products: ₹{subtotal.toFixed(2)}</p>
//             <p className="text-gray-700">Inclusive of GST (5%): ₹{gstAmount.toFixed(2)}</p>
//             <h3 className="text-xl font-bold mt-2">Total: ₹{totalPayable.toFixed(2)}</h3>

//             <button
//               onClick={handleCheckout}
//               disabled={hasStockIssue}
//               className={`hidden md:block mt-4 w-full rounded-md px-6 py-2 text-white ${
//                 hasStockIssue
//                   ? "cursor-not-allowed bg-gray-400"
//                   : "bg-blue-500 hover:bg-blue-600"
//               }`}
//               title={hasStockIssue ? "Adjust stock issues to continue" : "Proceed to Checkout"}
//             >
//               Proceed to Checkout →
//             </button>
//           </div>
//         )}
//       </div>

//       {/* Floating Bottom Bar for Mobile */}
//       {cartItems.length !== 0 && (
//         <div className="fixed bottom-0 left-0 w-full bg-green-600 text-white p-4 flex justify-between items-center md:hidden">
//           <div>
//             <p className="text-lg">{cartItems.length} {cartItems.length === 1 ? "item" : "items"}</p>
//             <p className="text-xl font-bold">₹{totalPayable.toFixed(2)}</p>
//           </div>
//           <button
//             onClick={handleCheckout}
//             disabled={hasStockIssue}
//             className={`rounded-md px-6 py-2 font-bold ${
//               hasStockIssue
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-white text-green-600"
//             }`}
//             title={hasStockIssue ? "Adjust stock issues to continue" : "Checkout Now"}
//           >
//             Checkout Now →
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }



// import React, { useEffect, useState, useMemo } from "react";
// import { analytics, auth, firestore as db } from "../FirebaseConfig";
// import { collection, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
// import { onAuthStateChanged } from "firebase/auth";
// import { useNavigate } from "react-router-dom";
// import { motion, AnimatePresence } from "framer-motion";
// import { 
//   IoTrashOutline, 
//   IoChevronBackOutline, 
//   IoBagCheckOutline, 
//   IoShieldCheckmarkOutline 
// } from "react-icons/io5";
// import { Truck, Sparkles, TrendingDown } from "lucide-react";
// import { logEvent } from "firebase/analytics";

// export default function CartPage() {
//   const [cartItems, setCartItems] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [userId, setUserId] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   // --- Constants ---
//   const FREE_DELIVERY_LIMIT = 299; 
//   const DELIVERY_FEE = 65;

//   // --- Core Logic ---
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setUserId(user ? user.uid : null);
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (userId) {
//       const fetchCartItems = async () => {
//         const cartRef = doc(db, "customers", userId);
//         const cartSnap = await getDoc(cartRef);
//         if (cartSnap.exists()) setCartItems(cartSnap.data().items || []);
//         setLoading(false);
//       };
//       fetchCartItems();
//     } else {
//       setCartItems([]);
//       setLoading(false);
//     }
//   }, [userId]);


//   const handleBackToShop = () => {
//     logEvent(analytics, 'cart_back_to_shop_clicked', {
//       current_cart_count: cartItems.length,
//       total_value: totals.finalAmount
//     });
//     navigate("/shop");
//   };

//   // Track Checkout Click
//   const handleCheckout = () => {
//     logEvent(analytics, 'cart_begin_checkout', {
//       value: totals.finalAmount,
//       price:  totals.finalAmount,
//       currency: 'INR',
//     });
//     navigate("/checkout");
//   };

//   useEffect(() => {
//     const fetchProductDetails = async () => {
//       const productsCollection = collection(db, "products");
//       const productSnapshots = await getDocs(productsCollection);
//       const productData = {};
//       productSnapshots.forEach((docSnap) => { productData[docSnap.id] = docSnap.data(); });
//       setProducts(productData);
//     };
//     fetchProductDetails();
//   }, []);

//   const updateQuantity = async (productId, change) => {
//     const updatedItems = cartItems.map((item) => {
//       if (item.productId !== productId) return item;
//       const product = products[item.productId];
//       const newQuantity = item.quantity + change;
//       if (newQuantity < 1) return null;
//       if (newQuantity > (product?.stock || 0)) return item;
//       return { ...item, quantity: newQuantity };
//     }).filter(Boolean);
//     setCartItems(updatedItems);
//     if (userId) await updateDoc(doc(db, "customers", userId), { items: updatedItems });
//   };

//   const removeItem = async (productId) => {
//     const updatedItems = cartItems.filter((item) => item.productId !== productId);
//     setCartItems(updatedItems);
//     if (userId) await updateDoc(doc(db, "customers", userId), { items: updatedItems });
//   };

//   // --- Calculations ---
//   const totals = useMemo(() => {
//     let sub = 0;
//     let save = 0;
//     cartItems.forEach(item => {
//       const p = products[item.productId];
//       if (p) {
//         sub += p.prices.productPrice * item.quantity;
//         save += p.prices.productDiscount * item.quantity;
//       }
//     });
//     const currentPayable = sub - save;
//     const isFree = currentPayable >= FREE_DELIVERY_LIMIT;
    
//     return { 
//       subtotal: sub, 
//       totalSavings: save, 
//       totalPayable: currentPayable,
//       isFreeDelivery: isFree,
//       finalAmount: isFree ? currentPayable : currentPayable + DELIVERY_FEE
//     };
//   }, [cartItems, products]);

//   const deliveryProgress = Math.min((totals.totalPayable / FREE_DELIVERY_LIMIT) * 100, 100);

//   if (loading) return <div className="min-h-screen bg-[#fdf5e6] flex items-center justify-center font-bold text-[#ff6b00]">Gleaning the hives...</div>;

//   return (
//     <div className="min-h-screen md:mt-10 bg-[#fdf5e6] pb-32 pt-12 md:pt-28 mt-20 font-sans">
//       <div className="max-w-5xl mx-auto px-4">
        
//         {/* Header Section - Compact */}
//         <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6">
//           <div>
//             <button onClick={ handleBackToShop} className="flex items-center gap-1 text-[9px] font-bold uppercase tracking-widest text-[#cc7700] mb-1 hover:opacity-70">
//               <IoChevronBackOutline /> Back to Shop
//             </button>
//             <h1 className="text-xl md:text-3xl font-black text-gray-900 tracking-tight">Your Honey Jar</h1>
//           </div>
//           <div className="bg-white/50 border border-orange-100 px-3 py-1.5 rounded-xl self-start">
//              <p className="text-[10px] font-bold text-gray-500 uppercase">Cart Items: <span className="text-[#ff6b00]">{cartItems.length}</span></p>
//           </div>
//         </div>

//         {cartItems.length === 0 ? (
//           <div className="bg-white rounded-[2rem] p-12 text-center shadow-sm border border-orange-100">
//             <span className="text-4xl mb-4 block">🍯</span>
//             <h2 className="text-lg font-bold text-gray-800">The jar is currently empty</h2>
//             <p className="text-gray-400 text-xs mt-2 mb-6 max-w-xs mx-auto">Fill it with nature's finest honey and start your journey to health.</p>
//             <button onClick={() => navigate("/shop")} className="bg-[#ff6b00] text-white px-8 py-2.5 rounded-full font-bold shadow-lg shadow-orange-200">Explore Hives</button>
//           </div>
//         ) : (
//           <div className="grid lg:grid-cols-12 gap-6 items-start">
            
//             {/* Left: Cart Items */}
//             <div className="lg:col-span-7 space-y-3">
              
//               {/* Delivery Bar - Updated to 299 */}
//               <div className="bg-white p-4 rounded-[1.5rem] border border-orange-100 shadow-sm relative overflow-hidden">
//                 <div className="flex justify-between items-center mb-2">
//                   <div className="flex items-center gap-2">
//                     <Truck size={14} className="text-[#ff6b00]" />
//                     <span className="text-[10px] font-bold text-gray-700 uppercase tracking-tight">
//                       {totals.isFreeDelivery ? "Free Delivery Unlocked!" : "Free Delivery Progress"}
//                     </span>
//                   </div>
//                   {!totals.isFreeDelivery && (
//                     <span className="text-[9px] font-black text-[#ff6b00]">Add ₹{(FREE_DELIVERY_LIMIT - totals.totalPayable).toFixed(0)} more</span>
//                   )}
//                 </div>
//                 <div className="h-1.5 w-full bg-orange-50 rounded-full overflow-hidden">
//                   <motion.div 
//                     initial={{ width: 0 }}
//                     animate={{ width: `${deliveryProgress}%` }}
//                     className="h-full bg-gradient-to-r from-[#ff6b00] to-[#cc7700]"
//                   />
//                 </div>
//               </div>

//               <AnimatePresence mode="popLayout">
//                 {cartItems.map((item) => {
//                   const product = products[item.productId];
//                   if (!product) return null;
//                   const currentPrice = product.prices.productPrice - product.prices.productDiscount;

//                   return (
//                     <motion.div 
//                       key={item.productId}
//                       layout
//                       className="bg-white p-3 md:p-4 rounded-[1.5rem] border border-orange-50 shadow-sm flex gap-4"
//                     >
//                       <div className="w-20 h-20 md:w-24 md:h-24 bg-[#fdf5e6] rounded-xl flex-shrink-0 p-1">
//                         <img src={product.thumbnail} className="w-full h-full object-contain" alt="" />
//                       </div>

//                       <div className="flex-1 flex flex-col justify-between">
//                         <div>
//                           <div className="flex justify-between items-start">
//                             <h3 className="text-[13px] md:text-base font-bold text-gray-800 leading-tight">{product.name}</h3>
//                             <button onClick={() => removeItem(item.productId)} className="text-gray-300 hover:text-red-500"><IoTrashOutline size={16}/></button>
//                           </div>
//                           <p className="text-[9px] font-bold text-gray-400 uppercase mt-0.5">{product.category}</p>
//                         </div>

//                         <div className="flex items-center justify-between mt-2">
//                           <div className="flex items-center bg-[#fdf5e6] rounded-lg px-1 py-0.5">
//                             <button onClick={() => updateQuantity(item.productId, -1)} className="w-7 h-7 flex items-center justify-center text-[#ff6b00] font-bold">-</button>
//                             <span className="w-5 text-center text-[11px] font-bold">{item.quantity}</span>
//                             <button onClick={() => updateQuantity(item.productId, 1)} className="w-7 h-7 flex items-center justify-center text-[#ff6b00] font-bold">+</button>
//                           </div>
//                           <div className="text-right">
//                             {product.prices.productDiscount > 0 && (
//                               <span className="block text-[9px] text-gray-300 line-through">₹{product.prices.productPrice * item.quantity}</span>
//                             )}
//                             <span className="text-sm md:text-base font-black text-gray-900">₹{currentPrice * item.quantity}</span>
//                           </div>
//                         </div>
//                       </div>
//                     </motion.div>
//                   );
//                 })}
//               </AnimatePresence>
//             </div>

//             {/* Right: Order Summary */}
//             <div className="lg:col-span-5 sticky top-28">
//               <div className="bg-white p-6 md:p-8 rounded-[2rem] shadow-xl shadow-orange-200/30 border border-orange-50">
//                 <h3 className="text-sm font-black text-gray-900 mb-5 uppercase tracking-widest">Bill Details</h3>
                
//                 <div className="space-y-3 mb-6">
//                   <div className="flex justify-between text-[11px] font-bold text-gray-500 uppercase">
//                     <span>Subtotal</span>
//                     <span>₹{totals.subtotal.toFixed(2)}</span>
//                   </div>
//                   <div className="flex justify-between text-[11px] font-bold text-emerald-600 uppercase">
//                     <span className="flex items-center gap-1"><TrendingDown size={12}/> Product Savings</span>
//                     <span>- ₹{totals.totalSavings.toFixed(2)}</span>
//                   </div>
//                   <div className="flex justify-between text-[11px] font-bold text-gray-500 uppercase">
//                     <span>Delivery Fee</span>
//                     {totals.isFreeDelivery ? (
//                        <div className="text-right">
//                          <span className="line-through text-gray-300 mr-2">₹{DELIVERY_FEE}</span>
//                          <span className="text-emerald-600">FREE</span>
//                        </div>
//                     ) : (
//                       <span>₹{DELIVERY_FEE.toFixed(2)}</span>
//                     )}
//                   </div>
//                   {totals.isFreeDelivery && (
//                     <div className="bg-emerald-50 p-2 rounded-lg flex items-center gap-2 border border-emerald-100">
//                       <Sparkles size={12} className="text-emerald-600" />
//                       <span className="text-[10px] font-bold text-emerald-700">You saved ₹{DELIVERY_FEE} on delivery!</span>
//                     </div>
//                   )}
//                 </div>

//                 <div className="border-t border-dashed border-orange-100 pt-5 mb-6">
//                   <div className="flex justify-between items-center">
//                     <span className="text-xs font-bold text-gray-800 uppercase">Total Payable</span>
//                     <span className="text-xl font-black text-[#ff6b00]">₹{totals.finalAmount.toFixed(2)}</span>
//                   </div>
//                 </div>

//                 <button
//                   onClick={handleCheckout}
//                   className="w-full bg-gradient-to-r from-[#ff6b00] to-[#cc7700] text-white py-3.5 rounded-xl font-bold uppercase tracking-widest text-[10px] flex items-center justify-center gap-2 shadow-lg shadow-orange-200"
//                 >
//                   <IoBagCheckOutline size={18} />
//                   Checkout Now
//                 </button>
//               </div>
//             </div>

//           </div>
//         )}
//       </div>

//       {/* Floating Mobile Dock - Updated with Savings and Delivery info */}
//       {cartItems.length > 0 && (
//         <div className="md:hidden fixed bottom-6 left-4 right-4 z-50">
//           <motion.div 
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             className="bg-white rounded-2xl p-4 flex items-center justify-between shadow-2xl border border-orange-100"
//           >
//             <div>
//               <div className="flex items-center gap-1.5 mb-0.5">
//                 <p className="text-[10px] font-bold text-emerald-600 uppercase">
//                   Saved ₹{totals.totalSavings + (totals.isFreeDelivery ? DELIVERY_FEE : 0)}
//                 </p>
//                 {totals.isFreeDelivery && (
//                    <span className="bg-emerald-100 text-emerald-700 text-[8px] px-1.5 py-0.5 rounded-full font-black uppercase">Free Delivery</span>
//                 )}
//               </div>
//               <p className="text-lg font-black text-gray-900">₹{totals.finalAmount.toFixed(2)}</p>
//             </div>
//             <button 
//               onClick={handleCheckout}
//               className="bg-[#ff6b00] text-white px-6 py-3 rounded-xl font-black uppercase tracking-widest text-[10px]"
//             >
//               Checkout
//             </button>
//           </motion.div>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useState, useMemo } from "react";
import { analytics, auth, firestore as db } from "../FirebaseConfig";
import { collection, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { 
  IoTrashOutline, 
  IoChevronBackOutline, 
  IoBagCheckOutline 
} from "react-icons/io5";
import { Truck, Sparkles, TrendingDown } from "lucide-react";
import { logEvent } from "firebase/analytics";

export default function CartPage() {
  const [cartItems, setCartItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // --- Constants ---
  const FREE_DELIVERY_LIMIT = 299; 
  const DELIVERY_FEE = 65;

  // --- Core Logic ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUserId(user ? user.uid : null);
    });
    return () => unsubscribe();
  }, []);

  // useEffect(() => {
  //   if (userId) {
  //     const fetchCartItems = async () => {
  //       const cartRef = doc(db, "customers", userId);
  //       const cartSnap = await getDoc(cartRef);
  //       if (cartSnap.exists()) setCartItems(cartSnap.data().items || []);
  //       setLoading(false);
  //     };
  //     fetchCartItems();
  //   } else {
  //     setCartItems([]);
  //     setLoading(false);
  //   }
  // }, [userId]);

  // useEffect(() => {
  //   const fetchProductDetails = async () => {
  //     const productsCollection = collection(db, "products");
  //     const productSnapshots = await getDocs(productsCollection);
  //     const productData = {};
  //     productSnapshots.forEach((docSnap) => { productData[docSnap.id] = docSnap.data(); });
  //     setProducts(productData);
  //   };
  //   fetchProductDetails();
  // }, []);

  // --- Replace your two data-fetching useEffect hooks with this single one ---
useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
    setLoading(true); // 1. Start loading state
    if (currentUser) {
      setUserId(currentUser.uid);
      try {
        // 2. Fetch both cart items and product details concurrently
        const [cartSnap, productsSnap] = await Promise.all([
          getDoc(doc(db, "customers", currentUser.uid)),
          getDocs(collection(db, "products"))
        ]);

        if (cartSnap.exists()) {
          setCartItems(cartSnap.data().items || []);
        }

        const productData = {};
        productsSnap.forEach((docSnap) => {
          productData[docSnap.id] = docSnap.data();
        });
        setProducts(productData);
      } catch (error) {
        console.error("Error loading cart data:", error);
      } finally {
        setLoading(false); // 3. Turn off loading only when data is fully ready
      }
    } else {
      setUserId(null);
      setCartItems([]);
      try {
        // Fetch products even for logged-out users if needed
        const productsSnap = await getDocs(collection(db, "products"));
        const productData = {};
        productsSnap.forEach((docSnap) => {
          productData[docSnap.id] = docSnap.data();
        });
        setProducts(productData);
      } catch (error) {
        console.error("Error loading products:", error);
      } finally {
        setLoading(false);
      }
    }
  });

  return () => unsubscribe();
}, []);


  // --- Filter Out "Delivery" Products ---
  // This prevents any dummy delivery items from rendering or affecting calculations
  const validCartItems = useMemo(() => {
    return cartItems.filter(item => {
      const product = products[item.productId];
      if (!product) return false;
      
      const isDelivery = 
        product.name?.toLowerCase().includes("delivery") || 
        product.category?.toLowerCase() === "delivery";
        
      return !isDelivery; 
    });
  }, [cartItems, products]);

  const handleBackToShop = () => {
    logEvent(analytics, 'cart_back_to_shop_clicked', {
      current_cart_count: validCartItems.length,
      total_value: totals.finalAmount
    });
    navigate("/shop");
  };

  const handleCheckout = () => {
    logEvent(analytics, 'cart_begin_checkout', {
      value: totals.finalAmount,
      currency: 'INR',
    });
    navigate("/checkout");
  };

  const updateQuantity = async (productId, change) => {
    const updatedItems = cartItems.map((item) => {
      if (item.productId !== productId) return item;
      const product = products[item.productId];
      const newQuantity = item.quantity + change;
      if (newQuantity < 1) return null;
      if (newQuantity > (product?.stock || 0)) return item;
      return { ...item, quantity: newQuantity };
    }).filter(Boolean);
    
    setCartItems(updatedItems);
    if (userId) await updateDoc(doc(db, "customers", userId), { items: updatedItems });
  };

  const removeItem = async (productId) => {
    const updatedItems = cartItems.filter((item) => item.productId !== productId);
    setCartItems(updatedItems);
    if (userId) await updateDoc(doc(db, "customers", userId), { items: updatedItems });
  };

  // --- Calculations ---
  const totals = useMemo(() => {
    let sub = 0;
    let save = 0;
    
    // Calculate only on valid items (excluding delivery products)
    validCartItems.forEach(item => {
      const p = products[item.productId];
      if (p) {
        sub += p.prices.productPrice * item.quantity;
        save += p.prices.productDiscount * item.quantity;
      }
    });
    
    const currentPayable = sub - save;
    const isFree = currentPayable >= FREE_DELIVERY_LIMIT;
    
    return { 
      subtotal: sub, 
      totalSavings: save, 
      totalPayable: currentPayable,
      isFreeDelivery: isFree,
      finalAmount: isFree ? currentPayable : currentPayable + DELIVERY_FEE
    };
  }, [validCartItems, products]);

  const deliveryProgress = Math.min((totals.totalPayable / FREE_DELIVERY_LIMIT) * 100, 100);

  // if (loading) return <div className="min-h-screen bg-[#fdf5e6] flex items-center justify-center font-bold text-[#ff6b00]">Gleaning the hives...</div>;
// --- Replace `if (loading) return (...)` with this Skeleton UI ---
if (loading) {
  return (
    <div className="min-h-screen md:mt-10 bg-[#fdf5e6] pb-32 pt-12 md:pt-28 mt-20 font-sans">
      <div className="max-w-5xl mx-auto px-4 animate-pulse">
        
        {/* Header Skeleton */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6">
          <div className="space-y-2">
            <div className="w-24 h-3 bg-amber-200/50 rounded" />
            <div className="w-48 h-7 bg-amber-200/60 rounded" />
          </div>
          <div className="w-28 h-7 bg-white/60 rounded-xl" />
        </div>

        <div className="grid lg:grid-cols-12 gap-6 items-start">
          
          {/* Left Column Skeletons (Delivery bar + Cart items) */}
          <div className="lg:col-span-7 space-y-3">
            {/* Delivery Progress Skeleton */}
            <div className="bg-white/70 p-4 rounded-[1.5rem] border border-orange-100/50 space-y-2">
              <div className="flex justify-between">
                <div className="w-36 h-3 bg-gray-200 rounded" />
                <div className="w-20 h-3 bg-gray-200 rounded" />
              </div>
              <div className="h-1.5 w-full bg-gray-100 rounded-full" />
            </div>

            {/* Cart Item Cards Skeletons */}
            {[1, 2].map((i) => (
              <div key={i} className="bg-white/70 p-3 md:p-4 rounded-[1.5rem] border border-orange-50/50 flex gap-4">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-gray-200/60 rounded-xl shrink-0" />
                <div className="flex-1 flex flex-col justify-between py-1">
                  <div className="space-y-2">
                    <div className="w-3/4 h-4 bg-gray-200 rounded" />
                    <div className="w-1/4 h-3 bg-gray-200 rounded" />
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="w-20 h-7 bg-gray-200 rounded-lg" />
                    <div className="w-14 h-5 bg-gray-200 rounded" />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right Column Skeleton (Order Summary) */}
          <div className="lg:col-span-5">
            <div className="bg-white/70 p-6 md:p-8 rounded-[2rem] border border-orange-50/50 space-y-4">
              <div className="w-28 h-4 bg-gray-200 rounded mb-6" />
              <div className="flex justify-between"><div className="w-16 h-3 bg-gray-200 rounded" /><div className="w-12 h-3 bg-gray-200 rounded" /></div>
              <div className="flex justify-between"><div className="w-24 h-3 bg-gray-200 rounded" /><div className="w-14 h-3 bg-gray-200 rounded" /></div>
              <div className="flex justify-between"><div className="w-20 h-3 bg-gray-200 rounded" /><div className="w-10 h-3 bg-gray-200 rounded" /></div>
              <div className="h-px bg-gray-100 my-4" />
              <div className="flex justify-between"><div className="w-24 h-5 bg-gray-200 rounded" /><div className="w-20 h-6 bg-gray-200 rounded" /></div>
              <div className="w-full h-12 bg-amber-200/60 rounded-xl mt-4" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
  return (
    <div className="min-h-screen md:mt-10 bg-[#fdf5e6] pb-32 pt-12 md:pt-28 mt-20 font-sans">
      <div className="max-w-5xl mx-auto px-4">
        
        {/* Header Section - Compact */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6">
          <div>
            <button onClick={ handleBackToShop} className="flex items-center gap-1 text-[9px] font-bold uppercase tracking-widest text-[#cc7700] mb-1 hover:opacity-70">
              <IoChevronBackOutline /> Back to Shop
            </button>
            <h1 className="text-xl md:text-3xl font-black text-gray-900 tracking-tight">Your Honey Jar</h1>
          </div>
          <div className="bg-white/50 border border-orange-100 px-3 py-1.5 rounded-xl self-start">
             <p className="text-[10px] font-bold text-gray-500 uppercase">Cart Items: <span className="text-[#ff6b00]">{validCartItems.length}</span></p>
          </div>
        </div>

        {validCartItems.length === 0 ? (
          <div className="bg-white rounded-[2rem] p-12 text-center shadow-sm border border-orange-100">
            <span className="text-4xl mb-4 block">🍯</span>
            <h2 className="text-lg font-bold text-gray-800">The jar is currently empty</h2>
            <p className="text-gray-400 text-xs mt-2 mb-6 max-w-xs mx-auto">Fill it with nature's finest honey and start your journey to health.</p>
            <button onClick={() => navigate("/shop")} className="bg-[#ff6b00] text-white px-8 py-2.5 rounded-full font-bold shadow-lg shadow-orange-200">Explore Hives</button>
          </div>
        ) : (
          <div className="grid lg:grid-cols-12 gap-6 items-start">
            
            {/* Left: Cart Items */}
            <div className="lg:col-span-7 space-y-3">
              
              {/* Delivery Bar */}
              <div className="bg-white p-4 rounded-[1.5rem] border border-orange-100 shadow-sm relative overflow-hidden">
                <div className="flex justify-between items-center mb-2">
                  <div className="flex items-center gap-2">
                    <Truck size={14} className="text-[#ff6b00]" />
                    <span className="text-[10px] font-bold text-gray-700 uppercase tracking-tight">
                      {totals.isFreeDelivery ? "Free Delivery Unlocked!" : "Free Delivery Progress"}
                    </span>
                  </div>
                  {!totals.isFreeDelivery && (
                    <span className="text-[9px] font-black text-[#ff6b00]">Add ₹{(FREE_DELIVERY_LIMIT - totals.totalPayable).toFixed(0)} more</span>
                  )}
                </div>
                <div className="h-1.5 w-full bg-orange-50 rounded-full overflow-hidden">
                  <motion.div 
                    initial={{ width: 0 }}
                    animate={{ width: `${deliveryProgress}%` }}
                    className="h-full bg-gradient-to-r from-[#ff6b00] to-[#cc7700]"
                  />
                </div>
              </div>

              <AnimatePresence mode="popLayout">
                {validCartItems.map((item) => {
                  const product = products[item.productId];
                  const currentPrice = product.prices.productPrice - product.prices.productDiscount;

                  return (
                    <motion.div 
                      key={item.productId}
                      layout
                      className="bg-white p-3 md:p-4 rounded-[1.5rem] border border-orange-50 shadow-sm flex gap-4"
                    >
                      <div className="w-20 h-20 md:w-24 md:h-24 bg-[#fdf5e6] rounded-xl flex-shrink-0 p-1">
                        <img src={product.thumbnail} className="w-full h-full object-contain" alt="" />
                      </div>

                      <div className="flex-1 flex flex-col justify-between">
                        <div>
                          <div className="flex justify-between items-start">
                            <h3 className="text-[13px] md:text-base font-bold text-gray-800 leading-tight">{product.name}</h3>
                            <button onClick={() => removeItem(item.productId)} className="text-gray-300 hover:text-red-500"><IoTrashOutline size={16}/></button>
                          </div>
                          <p className="text-[9px] font-bold text-gray-400 uppercase mt-0.5">{product.category}</p>
                        </div>

                        <div className="flex items-center justify-between mt-2">
                          <div className="flex items-center bg-[#fdf5e6] rounded-lg px-1 py-0.5">
                            <button onClick={() => updateQuantity(item.productId, -1)} className="w-7 h-7 flex items-center justify-center text-[#ff6b00] font-bold">-</button>
                            <span className="w-5 text-center text-[11px] font-bold">{item.quantity}</span>
                            <button onClick={() => updateQuantity(item.productId, 1)} className="w-7 h-7 flex items-center justify-center text-[#ff6b00] font-bold">+</button>
                          </div>
                          <div className="text-right">
                            {product.prices.productDiscount > 0 && (
                              <span className="block text-[9px] text-gray-300 line-through">₹{product.prices.productPrice * item.quantity}</span>
                            )}
                            <span className="text-sm md:text-base font-black text-gray-900">₹{currentPrice * item.quantity}</span>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  );
                })}
              </AnimatePresence>
            </div>

            {/* Right: Order Summary */}
            <div className="lg:col-span-5 sticky top-28">
              <div className="bg-white p-6 md:p-8 rounded-[2rem] shadow-xl shadow-orange-200/30 border border-orange-50">
                <h3 className="text-sm font-black text-gray-900 mb-5 uppercase tracking-widest">Bill Details</h3>
                
                <div className="space-y-3 mb-6">
                  <div className="flex justify-between text-[11px] font-bold text-gray-500 uppercase">
                    <span>Subtotal</span>
                    <span>₹{totals.subtotal.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between text-[11px] font-bold text-emerald-600 uppercase">
                    <span className="flex items-center gap-1"><TrendingDown size={12}/> Product Savings</span>
                    <span>- ₹{totals.totalSavings.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between text-[11px] font-bold text-gray-500 uppercase">
                    <span>Delivery Fee</span>
                    {totals.isFreeDelivery ? (
                       <div className="text-right">
                         <span className="line-through text-gray-300 mr-2">₹{DELIVERY_FEE}</span>
                         <span className="text-emerald-600">FREE</span>
                       </div>
                    ) : (
                      <span>₹{DELIVERY_FEE.toFixed(2)}</span>
                    )}
                  </div>
                  {totals.isFreeDelivery && (
                    <div className="bg-emerald-50 p-2 rounded-lg flex items-center gap-2 border border-emerald-100">
                      <Sparkles size={12} className="text-emerald-600" />
                      <span className="text-[10px] font-bold text-emerald-700">You saved ₹{DELIVERY_FEE} on delivery!</span>
                    </div>
                  )}
                </div>

                <div className="border-t border-dashed border-orange-100 pt-5 mb-6">
                  <div className="flex justify-between items-center">
                    <span className="text-xs font-bold text-gray-800 uppercase">Total Payable</span>
                    <span className="text-xl font-black text-[#ff6b00]">₹{totals.finalAmount.toFixed(2)}</span>
                  </div>
                </div>

                <button
                  onClick={handleCheckout}
                  className="w-full bg-gradient-to-r from-[#ff6b00] to-[#cc7700] text-white py-3.5 rounded-xl font-bold uppercase tracking-widest text-[10px] flex items-center justify-center gap-2 shadow-lg shadow-orange-200"
                >
                  <IoBagCheckOutline size={18} />
                  Checkout Now
                </button>
              </div>
            </div>

          </div>
        )}
      </div>

      {/* Floating Mobile Dock */}
      {validCartItems.length > 0 && (
        <div className="md:hidden fixed bottom-6 left-4 right-4 z-50">
          <motion.div 
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="bg-white rounded-2xl p-4 flex items-center justify-between shadow-2xl border border-orange-100"
          >
            <div>
              <div className="flex items-center gap-1.5 mb-0.5">
                <p className="text-[10px] font-bold text-emerald-600 uppercase">
                  Saved ₹{totals.totalSavings + (totals.isFreeDelivery ? DELIVERY_FEE : 0)}
                </p>
                {totals.isFreeDelivery && (
                   <span className="bg-emerald-100 text-emerald-700 text-[8px] px-1.5 py-0.5 rounded-full font-black uppercase">Free Delivery</span>
                )}
              </div>
              <p className="text-lg font-black text-gray-900">₹{totals.finalAmount.toFixed(2)}</p>
            </div>
            <button 
              onClick={handleCheckout}
              className="bg-[#ff6b00] text-white px-6 py-3 rounded-xl font-black uppercase tracking-widest text-[10px]"
            >
              Checkout
            </button>
          </motion.div>
        </div>
      )}
    </div>
  );
}